import { Component, Vue } from 'vue-property-decorator'

@Component
export default class scroll extends Vue {
  scroll = {
    y: 0,
    container: ''
  }

  /** 新增 scroll 监听 */
  $addScrollListener (container: string) {
    this.scroll.container = container
    document.querySelector(this.scroll.container) && document.querySelector(this.scroll.container).addEventListener('scroll', this.$handleScroll)
  }

  /** 移除 scroll 监听 */
  $removeScrollListener () {
    this.scroll.container && document.querySelector(this.scroll.container) && document.querySelector(this.scroll.container).removeEventListener('scroll', this.$handleScroll)
  }

  $handleScroll () {
    const node = document.querySelector(this.scroll.container)
    this.scroll.y = (node && node.scrollTop) || 0
    // console.log(`***handleScroll ${this.scroll.container}`, this.scroll.y)
  }

  /** 进入 activated 状态设置 scrollTo  */
  $setScrollY () {
    if (this.scroll.container) {
      document.querySelector(this.scroll.container).scrollTop = 10
      if (this.scroll.y > 0) {
        document.querySelector(this.scroll.container).scrollTo(0, this.scroll.y)
        this.scroll.y = 0
        document.querySelector(this.scroll.container).addEventListener('scroll', this.$handleScroll)
      }
    }
  }

  $getScrollY () {
    return this.scroll.y
  }
}
